import "vant/es/image-preview/style";
import _ImagePreview from "vant/es/image-preview";
import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import "vant/es/dialog/style";
import _Dialog from "vant/es/dialog";
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-59cc5690"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "upload-view"
};
const _hoisted_2 = {
  key: 0,
  class: "upload-hint"
};
const _hoisted_3 = {
  class: "upload-list"
};
const _hoisted_4 = ["onClick", "onTouchstart", "onTouchend"];
const _hoisted_5 = {
  class: "cover"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "select-mask"
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  key: 1,
  class: "preview-video"
};
const _hoisted_10 = ["src"];

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "play-btn"
}, null, -1));

const _hoisted_12 = {
  key: 0,
  id: "videoPlayer",
  controls: ""
};
const _hoisted_13 = {
  key: 1,
  class: "manage-bar"
};
const _hoisted_14 = {
  class: "manage-count"
};
const _hoisted_15 = {
  class: "manage-actions"
};
import { nextTick, ref } from 'vue';
import Compressor from 'compressorjs';
import composition from '@/composition';
export default {
  setup(__props, {
    expose
  }) {
    const {
      request
    } = composition(); // 文件列表

    const fileList = ref([]); // 文件类型 0 图片 1视频

    const fileType = ref(-1); // 上传文件

    const uploader = ref(null); // 展示sheet

    const show = ref(false);
    const actions = ref([{
      name: '查看'
    }, {
      name: '设为封面'
    }, {
      name: '删除',
      color: '#FF1743'
    }]); // 选中图片index

    const selectImgIndex = ref(-1); // 封面index

    const coverIndex = ref(0);
    const videoShow = ref(false); // 管理模式

    const isManaging = ref(false);
    const selectedIndexes = ref([]); // 进入管理模式

    function enterManage() {
      isManaging.value = true;
      selectedIndexes.value = [];
    } // 退出管理模式


    function exitManage() {
      isManaging.value = false;
      selectedIndexes.value = [];
    } // 切换选中


    function toggleSelect(index) {
      const idx = selectedIndexes.value.indexOf(index);

      if (idx > -1) {
        selectedIndexes.value.splice(idx, 1);
      } else {
        selectedIndexes.value.push(index);
      }
    } // 批量删除


    function batchDelete() {
      if (selectedIndexes.value.length === 0) return;

      _Dialog.confirm({
        title: '提示',
        message: `确定删除选中的 ${selectedIndexes.value.length} 张图片？`
      }).then(() => {
        const sorted = [...selectedIndexes.value].sort((a, b) => b - a);
        sorted.forEach(idx => {
          fileList.value.splice(idx, 1);
        }); // 重新调整封面图

        if (coverIndex.value >= 0 && selectedIndexes.value.includes(coverIndex.value)) {
          coverIndex.value = 0;
        } else {
          let removedCount = 0;
          [...selectedIndexes.value].sort((a, b) => a - b).forEach(idx => {
            if (coverIndex.value > idx) removedCount++;
          });
          coverIndex.value = Math.max(0, coverIndex.value - removedCount);
        }

        if (fileList.value.length === 0) {
          fileType.value = -1;
        }

        exitManage();
      });
    } // 点击上传文件


    function selectFile() {
      uploader.value.chooseFile();
    } // 点击图片


    function clickImage(index) {
      selectImgIndex.value = index;
      show.value = true;
    } // 长按检测


    const longPressTimer = ref(null);
    const isLongPress = ref(false);

    function onTouchStart(e, index) {
      // 管理模式不拦截，让 click 正常触发
      if (isManaging.value) return;
      e.preventDefault();
      isLongPress.value = false;
      longPressTimer.value = setTimeout(() => {
        isLongPress.value = true;
        longPressDelete(index);
      }, 600);
    }

    function onTouchEnd(e) {
      if (isManaging.value) return;
      e.preventDefault();
      clearTimeout(longPressTimer.value); // 如果是长按，阻止后续 click 事件

      if (isLongPress.value) {
        e.stopPropagation();
      }
    }

    function onTouchMove() {
      if (isManaging.value) return;
      clearTimeout(longPressTimer.value);
    } // 长按删除


    function longPressDelete(index) {
      const label = fileType.value == 1 ? '视频' : '图片';

      _Dialog.confirm({
        title: '提示',
        message: `确定删除该${label}？`
      }).then(() => {
        fileList.value.splice(index, 1); // 重新调整封面图

        if (coverIndex.value > index) {
          coverIndex.value -= 1;
        } else if (coverIndex.value == index) {
          coverIndex.value = 0;
        }

        if (fileList.value.length == 0) {
          fileType.value = -1;
        }
      });
    } // 超出数量限制


    function onOversize() {
      if (fileType.value == 1) {
        _Toast('最多只能上传1个视频');
      } else {
        _Toast('最多只能上传9张图片');
      }
    } // 隐藏视频


    function hideVideo() {
      const videoPlayer = document.getElementById('videoPlayer');
      videoPlayer.pause();
      videoShow.value = false;
    } // 点击选择


    function onSelect(item, index) {
      if (index == 0) {
        if (fileType.value == 0) {
          // 查看大图
          const imageList = fileList.value.map(item => item.content);

          _ImagePreview({
            images: imageList,
            startPosition: selectImgIndex.value
          });
        } else if (fileType.value == 1) {
          // 查看视频
          videoShow.value = true;
          const selectItem = fileList.value[selectImgIndex.value];
          nextTick(() => {
            const videoPlayer = document.getElementById('videoPlayer');
            videoPlayer.src = selectItem.content;
            videoPlayer.play();
          });
        }
      } else if (index == 1) {
        // 设置封面图
        coverIndex.value = selectImgIndex.value;
      } else if (index == 2) {
        // 删除
        _Dialog.confirm({
          title: '提示',
          message: '确定删除该图片？'
        }).then(() => {
          fileList.value.splice(selectImgIndex.value, 1); // 重新调整封面图

          if (coverIndex.value > selectImgIndex.value) {
            // 大于
            coverIndex.value -= 1;
          } else if (coverIndex.value == selectImgIndex.value) {
            // 等于
            coverIndex.value = 0;
          }

          if (fileList.value.length == 0) {
            // 已清空
            fileType.value = -1;
          }
        });
      }

      show.value = false;
    } // 上传前（支持单文件 / 文件列表）


    const beforeRead = file => {
      // 判断是文件列表还是单文件
      const fileList_input = Array.isArray(file) ? file : [file];
      return new Promise(resolve => {
        const resultFiles = [];
        let started = 0;

        const processNext = index => {
          if (index >= fileList_input.length) {
            // 全部处理完毕
            if (fileList_input.length > 1) {
              resolve(resultFiles);
            } else {
              resolve(resultFiles[0] || false);
            }

            return;
          }

          const f = fileList_input[index];
          const isImage = f.type.indexOf('image/') !== -1;
          const isVideo = f.type.indexOf('video/') !== -1; // 首次选择：按首个有效文件类型锁定上传模式

          if (fileType.value === -1) {
            if (isImage) fileType.value = 0;else if (isVideo) fileType.value = 1;
          } // 过滤：类型不匹配 → 跳过


          if (fileType.value === 0 && !isImage) {
            processNext(index + 1);
            return;
          }

          if (fileType.value === 1 && !isVideo) {
            processNext(index + 1);
            return;
          } // 过滤：已达数量上限 → 跳过


          if (fileType.value === 0 && fileList.value.length + started >= 9) {
            processNext(index + 1);
            return;
          }

          if (fileType.value === 1 && fileList.value.length + started >= 1) {
            processNext(index + 1);
            return;
          }

          started++; // 图片压缩

          if (isImage) {
            new Compressor(f, {
              quality: 0.9,
              maxWidth: 1200,
              success: res => {
                resultFiles.push(new File([res], res.name, {
                  type: res.type
                }));
                processNext(index + 1);
              },

              error(err) {
                console.log(err.message);
                started--;
                processNext(index + 1);
              }

            });
            return;
          } // 视频直接通过


          resultFiles.push(f);
          processNext(index + 1);
        };

        processNext(0);
      });
    }; // 上传后


    const afterRead = res => {
      res.name = new Date().getTime();

      if (res.file.type.indexOf('video/') !== -1) {
        getFirstImg(res);
      }
    }; // 上传操作（STS Token + OSS 直传）


    function uploadFunc() {
      return new Promise((resolve, reject) => {
        if (fileList.value.length == 0) {
          resolve([]);
          return;
        }

        const files = fileList.value.map(element => {
          return element.file;
        });
        const requestList = files.map(file => request.uploadOSS(file));
        Promise.allSettled(requestList).then(results => {
          const successFiles = results.filter(r => r.status === 'fulfilled').map(r => r.value);

          if (successFiles.length === 0) {
            reject({
              message: '所有文件上传失败，请重试'
            });
            return;
          }

          resolve(successFiles);
        }).catch(error => {
          console.log('error', error);
          reject({
            message: '上传文件失败'
          });
        });
      });
    } // 获取视频第一帧


    function getFirstImg(res) {
      const video = document.createElement('video');
      video.muted = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.preload = 'auto';
      video.crossOrigin = 'anonymous';
      video.src = res.content; // iOS 需要元素在视口内才能渲染，用 opacity:0 代替离屏定位

      video.style.cssText = 'position:fixed;top:0;left:0;width:100px;height:100px;opacity:0;pointer-events:none;z-index:-1;';
      document.body.appendChild(video);
      let captured = false;
      let timer = null;
      const MAX_WAIT = 8000;

      const doCapture = () => {
        if (captured) return;
        captured = true;
        clearTimeout(timer);

        try {
          const canvas = document.createElement('canvas');
          canvas.width = 320;
          canvas.height = 150;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          res.poster = canvas.toDataURL('image/jpeg');
        } catch {// 捕获失败，忽略
        }

        cleanup();
      };

      const cleanup = () => {
        clearTimeout(timer);

        try {
          video.pause();
        } catch {}

        video.removeEventListener('playing', onPlaying);
        video.removeEventListener('seeked', doCapture);
        video.removeEventListener('loadedmetadata', onMeta);
        video.removeEventListener('error', cleanup);
        if (video.parentNode) document.body.removeChild(video);
      };

      const onMeta = () => {
        // 优先尝试 play 获取首帧（iOS 长视频上 seek 可能不触发帧解码）
        video.play().then(() => {// play 成功，等播放事件后截图
        }).catch(() => {
          // play 被阻止，退回到 seek 方式
          video.currentTime = 0.5;
          if (!captured) timer = setTimeout(doCapture, 4000);
        });
      };

      const onPlaying = () => {
        // 视频已开始播放（首帧已渲染），立即暂停并截图
        video.pause(); // 等两帧确保画面已绘制到 canvas 可读状态

        requestAnimationFrame(() => {
          requestAnimationFrame(doCapture);
        });
      };

      video.addEventListener('loadedmetadata', onMeta);
      video.addEventListener('playing', onPlaying);
      video.addEventListener('seeked', doCapture);
      video.addEventListener('error', cleanup); // 兜底超时

      timer = setTimeout(doCapture, MAX_WAIT);
      video.load();
    }

    expose({
      fileList,
      uploadFunc,
      fileType
    });
    return (_ctx, _cache) => {
      const _component_van_action_sheet = _resolveComponent("van-action-sheet");

      const _component_van_uploader = _resolveComponent("van-uploader");

      const _component_van_overlay = _resolveComponent("van-overlay");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [fileList.value.length > 0 && !isManaging.value ? (_openBlock(), _createElementBlock("p", _hoisted_2, [_createTextVNode(" 长按" + _toDisplayString(fileType.value == 1 ? '视频' : '图片') + "可删除。最多可上传" + _toDisplayString(fileType.value == 1 ? '1个视频' : '9个图片') + "。 ", 1), fileType.value == 0 && fileList.value.length >= 2 ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "manage-btn",
        onClick: enterManage
      }, "管理")) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_withDirectives(_createElementVNode("div", {
        class: "upload-btn",
        onClick: selectFile
      }, null, 512), [[_vShow, !isManaging.value && (fileType.value == 0 && fileList.value.length < 9 || fileType.value == 1 && fileList.value.length < 1 || fileType.value == -1)]]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["preview-img", {
            'selected-item': isManaging.value && selectedIndexes.value.includes(index)
          }]),
          key: item.name,
          onClick: $event => isManaging.value ? toggleSelect(index) : clickImage(index),
          onTouchstart: $event => onTouchStart($event, index),
          onTouchend: $event => onTouchEnd($event, index),
          onTouchmove: onTouchMove
        }, [_withDirectives(_createElementVNode("p", _hoisted_5, "封面", 512), [[_vShow, coverIndex.value == index]]), fileType.value == 0 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("img", {
          src: item.content,
          alt: ""
        }, null, 8, _hoisted_6), _withDirectives(_createElementVNode("div", _hoisted_7, [_createElementVNode("span", {
          class: _normalizeClass(["select-check", {
            checked: selectedIndexes.value.includes(index)
          }])
        }, [selectedIndexes.value.includes(index) ? (_openBlock(), _createElementBlock("span", _hoisted_8, "✓")) : _createCommentVNode("", true)], 2)], 512), [[_vShow, isManaging.value]])], 64)) : fileType.value == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [item.poster ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: item.poster,
          class: "video-poster",
          alt: ""
        }, null, 8, _hoisted_10)) : _createCommentVNode("", true), _hoisted_11])) : _createCommentVNode("", true)], 42, _hoisted_4);
      }), 128)), _createVNode(_component_van_action_sheet, {
        show: show.value,
        "onUpdate:show": _cache[0] || (_cache[0] = $event => show.value = $event),
        actions: actions.value,
        onSelect: onSelect,
        description: "操作",
        "cancel-text": "取消"
      }, null, 8, ["show", "actions"]), _createVNode(_component_van_uploader, {
        style: {
          "display": "none"
        },
        ref_key: "uploader",
        ref: uploader,
        multiple: true,
        "max-count": fileType.value == 1 ? 1 : 9,
        "before-read": beforeRead,
        "upload-text": '上传图片',
        "after-read": afterRead,
        modelValue: fileList.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => fileList.value = $event),
        accept: fileType.value == -1 ? 'image/*,video/*' : fileType.value == 0 ? 'image/*' : 'video/*',
        onOversize: onOversize
      }, null, 8, ["max-count", "modelValue", "accept"]), _createVNode(_component_van_overlay, {
        show: videoShow.value,
        "z-index": "3",
        onClick: hideVideo
      }, {
        default: _withCtx(() => [videoShow.value ? (_openBlock(), _createElementBlock("video", _hoisted_12)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["show"])]), isManaging.value ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("span", _hoisted_14, "已选择 " + _toDisplayString(selectedIndexes.value.length) + " 项", 1), _createElementVNode("div", _hoisted_15, [_createElementVNode("span", {
        class: "manage-cancel",
        onClick: exitManage
      }, "取消"), _createElementVNode("span", {
        class: _normalizeClass(["manage-delete", {
          disabled: selectedIndexes.value.length === 0
        }]),
        onClick: batchDelete
      }, "删除", 2)])])) : _createCommentVNode("", true)]);
    };
  }

};